/* Bundle saver bar — keeps every instance in sync with underwear quantity only. */
(() => {
  if (window.__cletteBundleSaverReady) return;
  window.__cletteBundleSaverReady = true;

  const ROOT_SELECTOR = '[data-clette-bundle-saver]';

  const eligibleHandles = (root) =>
    new Set(
      String(root.dataset.cletteBundleHandles || '')
        .split('|')
        .map((handle) => handle.trim())
        .filter(Boolean),
    );

  const eligibleQuantity = (root, cart) => {
    if (!cart || !Array.isArray(cart.items)) return Number(root.dataset.cletteBundleCount) || 0;
    const handles = eligibleHandles(root);
    return cart.items.reduce((quantity, item) => {
      if (!handles.has(String(item.handle || ''))) return quantity;
      return quantity + (Number(item.quantity) || 0);
    }, 0);
  };

  const readConfig = (root) => {
    const node = root.querySelector('[data-clette-bundle-config]');
    if (!node) return null;
    try {
      const parsed = JSON.parse(node.textContent || '{}');
      parsed.milestones = Array.isArray(parsed.milestones)
        ? parsed.milestones
            .filter((milestone) => milestone && Number(milestone.qty) > 0)
            .sort((a, b) => Number(a.qty) - Number(b.qty))
        : [];
      return parsed;
    } catch (error) {
      return null;
    }
  };

  const messageFor = (config, quantity) => {
    const next = config.milestones.find((milestone) => quantity < Number(milestone.qty));

    if (next) {
      const remaining = Number(next.qty) - quantity;
      return String(config.progressText || '')
        .replace('[count]', String(remaining))
        .replace('[items]', remaining === 1 ? config.itemSingular || 'item' : config.itemPlural || 'items')
        .replace('[reward]', next.reward || '');
    }

    const reached = config.milestones[config.milestones.length - 1];
    if (reached) {
      return String(config.completeText || '').replace('[reward]', reached.reward || '');
    }

    return '';
  };

  const render = (root, count) => {
    const quantity = Math.max(0, Number(count) || 0);
    root.dataset.cletteBundleCount = String(quantity);
    root.hidden = root.dataset.cletteBundleHideEmpty === 'true' && quantity === 0;

    root.querySelectorAll('[data-clette-bundle-step]').forEach((step) => {
      step.classList.toggle('is-active', quantity >= Number(step.dataset.cletteBundleStep));
    });
    root.querySelectorAll('[data-clette-bundle-connector]').forEach((connector) => {
      connector.classList.toggle('is-active', quantity >= Number(connector.dataset.cletteBundleConnector));
    });

    const messageNode = root.querySelector('[data-clette-bundle-message]');
    const config = readConfig(root);
    if (!messageNode || !config) return;
    messageNode.textContent = messageFor(config, quantity);
  };

  const renderAll = (cart) => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => render(root, eligibleQuantity(root, cart)));
  };

  const hydrate = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => render(root, root.dataset.cletteBundleCount));
  };

  document.addEventListener('clette:cart:updated', (event) => {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;
    renderAll(cart);
  });

  document.addEventListener('shopify:section:load', hydrate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || !window.fetch) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) renderAll(cart);
      })
      .catch(() => {});
  });
})();
